import { ViteSSG } from "vite-ssg";
import { createPinia } from "pinia";
import App from "./App.vue";
import { routes, scrollBehavior } from "./router";
import { loadSeoConfig } from "./composables/useSeo";
import { initGtm } from "./composables/useGtm";

import "./assets/main.css";

// ViteSSG cuida da criação do app, do router (history correto por ambiente)
// e da instância de head (@unhead/vue). As meta tags globais ficam em App.vue;
// as por-página, no composable useSeo.
export const createApp = ViteSSG(
  App,
  { routes, scrollBehavior },
  async ({ app, router }) => {
    app.use(createPinia());

    // Na build SSG, aguarda a config de SEO do admin (/public/seo-settings)
    // ANTES de renderizar, para congelar og_image_url/route_images no HTML
    // estático — assim crawlers sem JS recebem o que o admin configurou.
    if (import.meta.env.SSR) {
      await loadSeoConfig();
    }

    // Analytics (GTM): inerte sem VITE_GTM_ID; respeita o banner de cookies.
    // Só no cliente — na build SSG não há window.
    if (!import.meta.env.SSR) {
      initGtm(router);
    }

    router.onError((error) => {
      console.error("Erro de navegação:", error);
    });

    router.beforeEach((to) => {
      if (!to.name) {
        return { name: "home" };
      }
    });
  },
);
